<template>
  <section>
    <form method="post" @submit.prevent="send">
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title is-centered">
            {{ formTitle }}
          </p>
        </header>
        <section class="modal-card-body">
          <form-wrapper :validator="$v.form">
            <form-group
              horizontal
              name="active"
              :label="$t('attributes.activation_status')"
            >
              <b-switch v-model="form.active" name="active"></b-switch>
            </form-group>

            <b-field horizontal grouped>
              <template #label>
                {{ $t('attributes.logo') }}
                <b-tooltip type="is-dark" label="200x200/限jpg或png檔，500KB內">
                  <b-icon size="is-small" icon="help-circle-outline"></b-icon>
                </b-tooltip>
              </template>
              <b-field class="file">
                <a class="button is-primary" @click="onSelectLogoImage">
                  <b-icon icon="upload"></b-icon>
                  <span>{{ $t('message.upload_logo') }}</span>
                </a>
                <p
                  v-if="form.logo"
                  class="control logo-image"
                  :style="logoStyle"
                  @click.prevent="onClickImage(form.logo)"
                ></p>
              </b-field>
            </b-field>

            <form-group horizontal name="name" :label="$t('attributes.name')">
              <b-input
                v-model="form.name"
                @input="$v.form.name.$touch()"
                name="name"
                :placeholder="
                  $t('message.please_input') + $t('attributes.name')
                "
                expanded
              >
              </b-input>
            </form-group>

            <form-group horizontal name="vat" :label="$t('attributes.vat')">
              <b-input
                v-model="form.vat"
                @input="$v.form.vat.$touch()"
                name="vat"
                :placeholder="$t('message.please_input') + $t('attributes.vat')"
                expanded
              >
              </b-input>
            </form-group>

            <form-group horizontal name="firm_feature" label="商務差旅功能">
              <div>
                <div class="columns is-multiline is-mobile">
                  <b-checkbox
                    v-for="(option, index) in feature_options"
                    :key="index"
                    v-model="form.firm_feature"
                    class="column is-3 is-marginless"
                    :native-value="option.value"
                  >
                    {{ option.name }}
                  </b-checkbox>
                </div>
              </div>
            </form-group>

            <form-group horizontal name="tel" :label="$t('attributes.tel')">
              <b-input
                v-model="form.tel"
                @input="$v.form.tel.$touch()"
                name="tel"
                :placeholder="$t('message.please_input') + $t('attributes.tel')"
                expanded
              >
              </b-input>
            </form-group>

            <form-group
              horizontal
              name="service_tel"
              :label="$t('attributes.service_tel')"
            >
              <b-input
                v-model="form.service_tel"
                @input="$v.form.service_tel.$touch()"
                name="service_tel"
                :placeholder="
                  $t('message.please_input') + $t('attributes.service_tel')
                "
                expanded
              >
              </b-input>
            </form-group>

            <form-group
              addons
              horizontal
              name="description"
              :label="$t('attributes.description')"
            >
              <b-input
                v-model="form.description"
                @input="$v.form.description.$touch()"
                type="textarea"
                name="description"
                expanded
              >
              </b-input>
            </form-group>

            <form-group
              horizontal
              name="region_alias"
              :label="$t('attributes.region_alias')"
            >
              <b-field>
                <b-select v-model="form.region_enabled" name="region_enabled">
                  <option value="true">{{ $t('attributes.display') }}</option>
                  <option value="false">{{ $t('attributes.hide') }}</option>
                </b-select>
                <b-input
                  v-model.number="form.region_alias"
                  name="region_alias"
                  :placeholder="
                    $t('message.please_input') + $t('attributes.region_alias')
                  "
                  expanded
                ></b-input>
              </b-field>
            </form-group>

            <form-group
              horizontal
              name="area_alias"
              :label="$t('attributes.area_alias')"
            >
              <b-field>
                <b-select v-model="form.area_enabled" name="area_enabled">
                  <option value="true">{{ $t('attributes.display') }}</option>
                  <option value="false">{{ $t('attributes.hide') }}</option>
                </b-select>
                <b-input
                  v-model.number="form.area_alias"
                  name="area_alias"
                  :placeholder="
                    $t('message.please_input') + $t('attributes.area_alias')
                  "
                  expanded
                ></b-input>
              </b-field>
            </form-group>

            <form-group
              horizontal
              name="department_alias"
              :label="$t('attributes.department_alias')"
            >
              <b-field>
                <b-select
                  v-model="form.department_enabled"
                  name="department_enabled"
                >
                  <option value="true">{{ $t('attributes.display') }}</option>
                  <option value="false">{{ $t('attributes.hide') }}</option>
                </b-select>
                <b-input
                  v-model.number="form.department_alias"
                  name="department_alias"
                  :placeholder="
                    $t('message.please_input') +
                      $t('attributes.department_alias')
                  "
                  expanded
                ></b-input>
              </b-field>
            </form-group>

            <form-group
              horizontal
              name="section_alias"
              :label="$t('attributes.section_alias')"
            >
              <b-field>
                <b-select v-model="form.section_enabled" name="section_enabled">
                  <option value="true">{{ $t('attributes.display') }}</option>
                  <option value="false">{{ $t('attributes.hide') }}</option>
                </b-select>
                <b-input
                  v-model.number="form.section_alias"
                  name="section_alias"
                  :placeholder="
                    $t('message.please_input') + $t('attributes.section_alias')
                  "
                  expanded
                ></b-input>
              </b-field>
            </form-group>
          </form-wrapper>
        </section>
        <footer class="modal-card-foot">
          <b-button :loading="sending" @click="$parent.close()">
            {{ $t('attributes.cancel') }}
          </b-button>
          <b-button :loading="sending" type="is-primary" native-type="submit">
            {{ isEditing ? $t('attributes.update') : $t('attributes.add') }}
          </b-button>
        </footer>
      </div>
    </form>

    <b-modal :active.sync="isImageModalActive">
      <p class="image">
        <img :src="collaborateImage(selectedImageUrl)" alt="" />
      </p>
    </b-modal>
  </section>
</template>

<script>
import { required, maxLength } from 'vuelidate/lib/validators'
import { OpenMemberFinder } from '@/utils/ckfinder'
import notifyService from '@/services/notifyService'

export default {
  name: 'CollaborateForm',

  props: {
    sending: {
      type: Boolean,
      default: true
    },
    id: {
      type: Number,
      default: null
    },
    active: {
      type: Boolean,
      default: true
    },
    logo: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    vat: {
      type: String,
      default: ''
    },
    firm_feature: {
      type: String,
      default: '["tickets","internal","free","group","hotel","other"]'
    },
    tel: {
      type: String,
      default: ''
    },
    service_tel: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    region_alias: {
      type: String,
      default: '地區'
    },
    area_alias: {
      type: String,
      default: '處所'
    },
    department_alias: {
      type: String,
      default: '部門'
    },
    section_alias: {
      type: String,
      default: '課'
    },
    region_enabled: {
      type: Boolean,
      default: true
    },
    area_enabled: {
      type: Boolean,
      default: true
    },
    department_enabled: {
      type: Boolean,
      default: true
    },
    section_enabled: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      isEditing: this.id !== null,
      feature_options: [
        { value: 'tickets', name: '代訂機栗' },
        { value: 'internal', name: '國內旅遊' },
        { value: 'free', name: '機＋酒自由行' },
        { value: 'group', name: '團體旅遊' },
        { value: 'hotel', name: '代訂飯店' },
        { value: 'other', name: '其他' }
      ],
      form: {
        id: this.id,
        active: this.active,
        logo: this.logo,
        name: this.name,
        vat: this.vat,
        firm_feature: JSON.parse(this.firm_feature),
        tel: this.tel,
        service_tel: this.service_tel,
        description: this.description,
        region_alias: this.region_alias,
        area_alias: this.area_alias,
        department_alias: this.department_alias,
        section_alias: this.section_alias,
        region_enabled: this.region_enabled,
        area_enabled: this.area_enabled,
        department_enabled: this.department_enabled,
        section_enabled: this.section_enabled
      },
      isImageModalActive: false,
      selectedImageUrl: null
    }
  },
  validations: {
    form: {
      name: { required, maxLength: maxLength(50) },
      vat: { required, maxLength: maxLength(50) },
      tel: { maxLength: maxLength(20) },
      firm_feature: {},
      service_tel: { maxLength: maxLength(100) },
      description: { maxLength: maxLength(500) },
      region_alias: { maxLength: maxLength(50) },
      area_alias: { maxLength: maxLength(50) },
      department_alias: { maxLength: maxLength(50) },
      section_alias: { maxLength: maxLength(50) }
    }
  },
  computed: {
    logoStyle() {
      return {
        width: '36px',
        height: '36px',
        'background-image': `url(${this.collaborateImage(this.form.logo)})`
      }
    },
    formTitle() {
      let title =
        this.$t(this.isEditing ? 'attributes.modify' : 'attributes.add') +
        this.$t('attributes.collaborate')

      if (this.isEditing) {
        title += ' - ' + this.name
      }

      return title
    }
  },
  methods: {
    async onSelectLogoImage() {
      try {
        this.form.logo = await OpenMemberFinder()
      } catch (e) {
        notifyService.error(e)
      }
    },
    onClickImage(url) {
      this.isImageModalActive = true
      this.selectedImageUrl = url
    },
    async send() {
      this.$v.$touch()

      if (this.$v.$invalid) {
        return
      }

      const features = []
      for (const feature of this.feature_options) {
        if (this.form.firm_feature.includes(feature.value)) {
          features.push(feature.value)
        }
      }

      const data = {
        ...this.form,
        firm_feature: JSON.stringify(features)
      }

      this.$emit('onSend', data)
    }
  }
}
</script>

<style lang="scss" scoped>
.logo-image {
  cursor: pointer;
  margin-left: 6px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}

.image {
  width: 200px;
  height: auto;
  left: calc(50% - 100px);
}
</style>
